import { FilterKey } from "@/models/FilterKey";
import Filter from "../../Filter.class";
import { IFilterProvider } from "@/interfaces/filter-providers/IFilterProvider";

export default class EducationLevelFilter extends Filter {
	constructor(filterProvider: IFilterProvider) {
		super(FilterKey.EDUCATION_LEVEL, filterProvider);
	}
}
